export const ns = "CreateNote"

export default {
  [ns]: {
    write: "Écrire",
    draw: "Dessiner",
    takePic: "Prendre une photo",
  },
}
